<template>
    <div>
        <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{on}">
                <div style="position: relative" :id="uuid+'_integration'">
                    <v-chip v-on="on" small :color="integration.color" class="white--text">{{integration.integration_type}}</v-chip>
                </div>
            </template>
            <div>
                <div class="white pa-3">
                    <div>External ID : {{integration.external_id}}</div>
                    <div v-for="(detail, key) in details">{{key}} : <component target="_blank" :is="(validUrl(detail) == true)? 'a' : 'span'" :href="detail">{{detail}}</component></div>
                </div>
            </div>
        </v-menu>
    </div>
</template>
<script>
    import {makeid} from "../../helpers";

    export default {
        props:{
            integration:{
                required: true,
                type: Object
            }
        },
        data:() => {
            return{
                uuid : null
            }
        },
        computed:{
            details(){
                return this.integration.details || {};
            }
        },
        mounted() {
            this.uuid = makeid(30);
        },
        methods:{
            validUrl(string){
                return this.validationRules.validURL(string);
            }
        }
    }
</script>
